import {
  createAuthHeyClient,
  generateToken,
  type GenerateTokenResponse,
  type LoginTokens,
} from "@platform/api/auth";
import axios from "axios";

/** The backend API's base URL, ending in a slash. */
type ApiHost = string;

const authBaseUrl = (apiHost: ApiHost): string => `${apiHost}brokerportal/v1`;

export const logIn = async (
  apiHost: ApiHost,
  credentials: {
    readonly username: string;
    readonly password: string;
    readonly keepSignedIn: boolean;
  },
): Promise<GenerateTokenResponse> => {
  const { data } = await generateToken({
    client: createAuthHeyClient(authBaseUrl(apiHost)),
    body: credentials,
    throwOnError: true,
  });
  return data;
};

export const validateMfaCode = async (
  apiHost: ApiHost,
  code: string,
  userId: string,
): Promise<LoginTokens> => {
  const { data } = await axios.post<LoginTokens>(
    `${authBaseUrl(apiHost)}/validateMfa`,
    { code, userId },
  );
  return data;
};

export const sendMfaCode = async (
  apiHost: ApiHost,
  userId: string,
): Promise<void> => {
  await axios.post(`${authBaseUrl(apiHost)}/sendMfaCodeBrokerPortal`, {
    userId,
  });
};

export const resetPassword = async (
  apiHost: ApiHost,
  email: string,
): Promise<unknown> => {
  const { data } = await axios.post<unknown>(
    `${authBaseUrl(apiHost)}/reset-password`,
    { email },
  );
  return data;
};
